import ConsoleApi from "@/consoleapi/consoleApi";
import {AxiosResponse} from "axios";

/**
 *
 */
export default class Provider extends ConsoleApi {
    protected resource = '/providers';

    public get(accountId: string): Promise<AxiosResponse>{
        return this.axios.get(this.requestUri + this.getAccountResource(accountId), {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }
}